import { Stack } from '@mui/material';
import {
  IMPORT_MORE,
  usePortalioImport,
} from 'src/components/ImportPortalioProjectModal/portalio-import-context';
import { ImportResultsList } from 'src/components/ImportProposalsModal/import-results-list';
import { formatProjectCount } from 'src/components/ImportProposalsModal/import-results.utils';
import { ImportSummary } from 'src/components/ImportProposalsModal/import-summary';
import { ModalStep, useModalStep } from 'src/components/ModalContainer';

interface ImportCompletedStepProps {
  projectIds: number[];
  projectNames: Map<string, string>;
}

/** Step 3: what the import created and updated, per project. */
export const ImportCompletedStep = ({
  projectIds,
  projectNames,
}: ImportCompletedStepProps) => {
  const { popStep } = useModalStep();
  const { records, errors, openSite, close } = usePortalioImport();
  const importFailed = projectIds.length > 0 && records.length === 0;

  return (
    <ModalStep
      title={importFailed ? 'Import failed' : 'Import complete'}
      actions={[
        { label: 'Import more', kind: 'secondary', onClick: () => popStep(IMPORT_MORE) },
        {
          label: 'Done',
          kind: 'primary',
          onClick: close,
          testId: 'import-portalio-projects-results-done',
        },
      ]}
    >
      <Stack gap={1.5} data-testid="import-portalio-projects-results">
        <ImportSummary
          status={`${records.length} of ${formatProjectCount(projectIds.length)} imported`}
          records={records}
          tense="done"
          testId="import-portalio-projects-result"
        />
        <ImportResultsList
          records={records}
          errors={errors}
          projectNames={projectNames}
          loading={false}
          onOpenSite={openSite}
          testId="import-portalio-projects-result"
        />
      </Stack>
    </ModalStep>
  );
};
